module.exports = __webpack_public_path__ + "static/mattress-3-46e5d79160d59cda488d28c493edd585.jpg";